module.exports = __webpack_public_path__ + "static/media/ope_marru_818x1228.0b67c730.jpg";